// Add selectors to a const variable
/* const searchButton = document.querySelector('.topBar__search--button');
const searchContainer = document.querySelector('.topBar__search');
//On click, toggle active class on container
searchButton.onclick = () => searchContainer.classList.toggle('active'); */

// const buttonMobile = document.querySelector('#buttonMobile');
const mobileMenuButton = document.querySelector(".buttonMenu");
const mobileMenuContainer = document.querySelector("#buttonContainer");

(function($) {
	//Mobile menu button
	$(".buttonMenu").on("click", function() {
		console.log("Button click");
		$(this).addClass("open");
		$("#buttonContainer").toggleClass("open");
	});
	$(".close-menu-button").on("click", function(e) {
		console.log("click");
		console.log(e);
		e.preventDefault();
		$("#buttonMobile .buttonMenu").removeClass("open");
		$("#buttonContainer").removeClass("open");
	});
})(jQuery);
